import {PewComponent} from "../../../../themes/wwp_child_theme/assets/raw/js/components/pew-component";

export default class Brochure extends PewComponent {

  init() {
    this.recomputeIndexes();
    this.registerSearch(true);
    this.registerPagination(this.element.find('.pagination'));
  }

  isMobile() {
    return (window.innerWidth < 768);
  }

  camelize(str) {
    return str.toLowerCase().replace(
      /([-_][a-z])/g,
      (group) => group.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    );
  }

  recomputeIndexes() {
    jQuery('.module-otca-brochure').each(function (i, instance) {
      $(instance).data('index', i);
    });
  }

  loadPage(href, isPagination, cb) {
    var self = this;
    this.element.addClass('ajax-loading');
    $.get(href, {}, (res) => {
      this.element.removeClass('ajax-loading');
      var index = this.element.data('index');
      var $newContext = null;
      if (index) {
        $newContext = $($(res).find('.module-otca-brochure')[index]);
        $newContext.data('index', index);
      } else {
        $newContext = $(res).find('.module-otca-brochure').first();
      }
      this.element.find('.currently-loading').removeClass('currently-loading');

      this.handleNewContext($newContext, isPagination, cb);
    });
  }

  handleNewContext($newContext, isPagination, cb) {
    const $newItems = $newContext.find('.items-otca-brochure > *');
    const $wrap = this.element.find('.items-otca-brochure');
    this.element.find('.items-otca-brochure > *').remove();
    $wrap.append($newItems);

    this.replaceNbrItems($newContext.find('.nbr-items'));
    this.replacePagination($newContext.find('.pagination'));

    var topPos = $wrap && $wrap.offset() && $wrap.offset().top ? $wrap.offset().top : null;
    if(topPos) {
      if (window.smoothScrollMargin) {
        topPos -= window.smoothScrollMargin;
      }

      $('html,body').animate({
        scrollTop: topPos
      }, 750);
    }

    if (window.pew) {
      window.pew.enhanceRegistry(this.element.find('.items-otca-brochure')[0]);
    }
    cb && cb();
  }

  registerPagination($pagination) {
    $pagination.find('a.navlink').on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).replaceWith('<span class="loader loader--small"></span>');
      this.loadPage(e.currentTarget.href, true, this.newPageLoaded.bind(this));
    })
  }

  newPageLoaded() {

  }

  replaceNbrItems($nbrItems) {
    this.element.find('.nbr-items').replaceWith($nbrItems);
  }

  replacePagination($newPagination) {
    this.element.find('.pagination').replaceWith($newPagination);
    this.registerPagination($newPagination);
  }

  registerSearch(autoSubmit) {
    const $filtersForm = this.element.find('form.brochure-filters');
    $filtersForm.on('submit', (e) => {
      e.preventDefault();
      if (!this.element.hasClass('ajax-loading')) {
        this.handleFiltersSubmit($filtersForm);
      }
    });
    if (autoSubmit) {
      $filtersForm.addClass('auto-submit');

      //auto submit on input change
      const $inputs = $filtersForm.find('.checkbox, input, select').not('.exclude');
      $inputs.on('change', function () {
        $(this).parent().addClass('currently-loading');
        $filtersForm.submit();
      });

      //Possibility to uncheck a radio input
      $("input:radio:checked").data("chk",true);
      $inputs.on('click', function () {
        const check = $(this).data("chk");
        $("input:radio").data("chk",false);
        $(this).data("chk",!check);
        $(this).prop("checked", !check).trigger('change');
      });
    }
  }

  handleFiltersSubmit($filtersForm) {
    this.loadPage($filtersForm.prop('action') + '?' + $filtersForm.serialize());
  }

  serializeAssoc(rawFields) {
    let fields = {};
    $.each(rawFields, (i, field) => {
      fields[field.name] = field.value;
    });
    return fields;
  }

}

window.pew.addRegistryEntry({key: 'otca-brochure', classDef: Brochure, domSelector: '.module-otca-brochure'});
